//Config
import FacturesConfig from './_config/factures.config';
import FacturesRoutes from './_config/factures.routes';
//Components
import FacturesComponent from './components/factures';
import FacturesTabulatorComponent from './components/factures-tabulator';
import FacturesCheckpontComponent from './components/factures-checkpont';
import FacturesPontComponent from './components/factures-pont';
import FacturesXComponent from './components/factures-x';
import FacturesXErrorReportModalComponent from './components/factures-x/facturesXErrorReportModal';
import FacturesXProgressModalComponent from './components/factures-x/facturesXProgressModal';
import FacturXInfoComponent from './components/factures-x/facturXInfo';
// import FactureEnteteComponent from './components/factures';
// services
import ArticlesService from './services/articles.service';
import AvoirsService from './services/avoirs.service';
import FacturesCommunicationService from './services/factures.communication.service';
import FacturesService from './services/factures.service';
import FacturesXService from './services/factures-x.service';
import ReglementsService from './services/reglements.service';

import FactureComposantComponent from './components/facture-composant/';
import FactureFormComponent from './components/facture-form';
import FactureArticlesBlockComponent from './components/facture-form/articles-block';
import FactureFormArticlesChantierComponent from './components/facture-form/articles-chantier';
import FactureFormEnteteComponent from './components/facture-form/entete';
import FactureFormRecapComponent from './components/facture-form/recap';
import FactureFormReglementComponent from './components/facture-form/reglements';

import FactureDetailComponent from './components/facture-detail';

import FactureArticleValidator from './components/facture-form/articles-chantier/articles.validator';
import FactureEnteteValidator from './components/facture-form/entete/facture.entete.validator';
import FactureValidator from './components/facture-form/facture.validator';

import FacturePopupComponent from './components/facture-popup';
import FacturesPrintComponent from './components/factures-print';

import FactureAvoirFactClientComponent from './components/facture-avoir/fact-client';
import FactureAvoirInitComponent from './components/facture-avoir/init';
import FactureAvoirPartielRefactComponent from './components/facture-avoir/partiel-refact';
import FactureAvoirRecapComponent from './components/facture-avoir/recap';
import FactureAvoirSelectComponent from './components/facture-avoir/select';
import FactureAvoirUpdateComponent from './components/facture-avoir/update';

import FactureCloturePopupComponent from './components/facture-cloture-popup';
import ModaleUpdateComptantComponent from './components/facture-detail/modale-update-comptant';
const moduleName = 'app.massia.common.factures';

angular
	.module(moduleName, [])
	.config(FacturesConfig)
	.config(FacturesRoutes)
	.service('FacturesService', FacturesService)
	.service('FacturesXService', FacturesXService)
	.service('AvoirsService', AvoirsService)
	.service('ArticlesService', ArticlesService)
	.service('ReglementsService', ReglementsService)
	.service('FacturesCommunicationService', FacturesCommunicationService)
	.component('factures', FacturesComponent)
	.component('facturesTabulator', FacturesTabulatorComponent)
	.component('facturesPont', FacturesPontComponent)
	.component('facturesCheckpont', FacturesCheckpontComponent)
	.component('facturesX', FacturesXComponent)
	.component('facturesXErrorReportModal', FacturesXErrorReportModalComponent)
	.component('facturesXProgressModal', FacturesXProgressModalComponent)
	.component('facturXInfo', FacturXInfoComponent)
	.component('factureForm', FactureFormComponent)
	.component('factureFormEntete', FactureFormEnteteComponent)
	.component('factureFormRecap', FactureFormRecapComponent)
	.component('factureFormArticlesChantier', FactureFormArticlesChantierComponent)
	.component('factureArticlesBlock', FactureArticlesBlockComponent)
	.component('factureFormReglement', FactureFormReglementComponent)
	.component('factureDetail', FactureDetailComponent)
	.component('facturePopup', FacturePopupComponent)
	.component('facturesPrint', FacturesPrintComponent)
	.component('modaleUpdateComptant', ModaleUpdateComptantComponent)
	.component('factureComposant', FactureComposantComponent)
	.component('factureCloturePopup', FactureCloturePopupComponent)

	.component('factureAvoirInit', FactureAvoirInitComponent)
	.component('factureAvoirSelect', FactureAvoirSelectComponent)
	.component('factureAvoirUpdate', FactureAvoirUpdateComponent)
	.component('factureAvoirPartielRefact', FactureAvoirPartielRefactComponent)
	.component('factureAvoirFactClient', FactureAvoirFactClientComponent)
	.component('factureAvoirRecap', FactureAvoirRecapComponent)

	.factory('FactureValidator', FactureValidator)
	.factory('FactureEnteteValidator', FactureEnteteValidator)
	.factory('FactureArticleValidator', FactureArticleValidator);

export default moduleName;
